import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  GridList,
  GridListTile,
  Hidden,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import defaultImage from "../../../assets/ic_placeholder.png";
import OutOfStock from "../../../assets/out_of_stock.png";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CategoryStore from "../../../Store/CategoryStore";
import productStore from "../../../Store/ProductStore";
import promotionStore from "../../../Store/PromotionStore";
import TenantStore from "../../../Store/TenantStore";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import parse from "html-react-parser";

function DetailDialog(props) {
  const { title, dataMenu, deleted, approved, access, handleGetList, tabShow } =
    props;
  const [open, setOpen] = React.useState(true);
  const [, productActions] = productStore();
  const [, promotionActions] = promotionStore();
  const [categoryProductState, categoryProductActions] = CategoryStore();
  const [tenantState, tenantActions] = TenantStore();

  const user = JSON.parse(localStorage.getItem("user"));
  const userTenant = user.tenant.id;
  const handleClose = () => {
    setOpen(false);
  };
  const doEdit = () => {
    setOpen(false);
    props.proceed();
  };

  const setStatusReject = () => {
    // debugger;
    confirm(`Are you sure to Reject this item ?`).then(async (onProcess) => {
      await promotionActions.deletedTenant(dataMenu.id);
      let notif = `Successfully Reject Prmotion`;
      setOpen(false);
      handleGetList(true);
      props.cancel();
    });
  };

  const setStatusApproved = () => {
    confirm(`Approve`, `Are you sure to Approve this item ?`).then(
      async (onProcess) => {
        const params = [
          {
            op: "replace",
            path: "/approved",
            value: true,
          },
        ];
        let notif = `Successfully Approve Promotion Tenant`;
        await promotionActions.approvedTenant(dataMenu.id, params, notif);
        setOpen(false);
        handleGetList(true);
        props.cancel();
      }
    );
  };

  const setStatusRemove = () => {
    confirm(
      `${!deleted ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!deleted ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      if (!approved) {
        dataMenu.approved = true;
        await promotionActions.deletedTenant(dataMenu.id);
      } else {
        const params = [
          {
            op: "replace",
            path: "/approved",
            value: true,
          },
        ];
        let notif = `Successfully Restore Product`;
        await promotionActions.patchTenant(dataMenu.id, params, notif);
      }
      setOpen(false);
      handleGetList(true);
      props.cancel();
    });
  };

  const handleOpenDialog = () => {
    var query = {
      num: "200",
      cursor: "",
      position: "",
      search: "",
    };
    categoryProductActions.get(query);
    tenantActions.get(query);
  };

  // tenant
  const setSForTenantRemove = () => {
    confirm(`Are you sure to  remove this item ?`).then(async (onProcess) => {
      const params = [
        {
          op: "replace",
          path: "/approved",
          value: false,
        },
      ];
      let notif = `Successfully Restore Product`;
      await promotionActions.patchTenant(dataMenu.id, params, notif);
      await promotionActions.deletedTenant(dataMenu.id);

      setOpen(false);
      handleGetList(true);
      props.cancel();
    });
  };

  // restore tenant
  const setStatusForTenantRestore = () => {
    confirm(`Are you sure to restore this item ?`).then(async (onProcess) => {
      const params = [
        {
          op: "replace",
          path: "/approved",
          value: false,
        },
      ];
      let notif = `Successfully Restore Product`;
      await promotionActions.patchTenant(dataMenu.id, params, notif);
      setOpen(false);
      handleGetList(true);
      props.cancel();
    });
  };

  return (
    <div>
      <CustomizedDialogs
        disableBackdropClick
        maxWidth={"xs"}
        title={props.title}
        open={open}
        handleClose={handleClose}
      >
        {/* <DialogTitle id="alert-dialog-title">{title}</DialogTitle> */}
        <DialogContent>
          <Grid container direction="row" className="body-dialog">
            {dataMenu.out_of_stock && (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    color: "white",
                    position: "absolute",
                    marginTop: "10%",
                    zIndex: "100",
                    width: "80%",
                  }}
                >
                  <img
                    style={{
                      display: "block",
                      margin: "auto",
                    }}
                    src={OutOfStock}
                    alt={dataMenu.name}
                  />
                </Grid>
              </Grid>
            )}
            <Grid container spacing={5}>
              <Grid item xs={12} md={12}>
                <Hidden mdUp>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      overflow: "hidden",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <GridList
                      style={{
                        flexWrap: "nowrap",
                        transform: "translateZ(0)",
                      }}
                    >
                      {dataMenu.image_urls.map((image_url, keyImg) => {
                        return (
                          <GridListTile
                            key={image_url}
                            style={{
                              height: "auto",
                              alignSelf: "center",
                            }}
                          >
                            <Zoom zoomMargin={40}>
                              <img
                                src={
                                  image_url === "" ? defaultImage : image_url
                                }
                                alt={dataMenu.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                }}
                              />
                            </Zoom>
                          </GridListTile>
                        );
                      })}
                    </GridList>
                  </div>
                </Hidden>
                <Hidden smDown>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-around",
                      overflow: "hidden",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <GridList
                      style={{
                        width: "100%",
                        height: "100%",
                        maxHeight: "75vh",
                      }}
                      cellHeight={140}
                    >
                      {dataMenu.image_urls.map((image_url, keyImg) => {
                        return (
                          <GridListTile
                            key={image_url}
                            cols={1}
                            style={{
                              maxWidth: "100%",
                            }}
                          >
                            <Zoom zoomMargin={40}>
                              <img
                                src={
                                  image_url === "" ? defaultImage : image_url
                                }
                                alt={dataMenu.name}
                                className="img"
                                style={{
                                  width: "100%",
                                }}
                              />
                            </Zoom>
                          </GridListTile>
                        );
                      })}
                    </GridList>
                  </div>
                </Hidden>
              </Grid>
              <Grid item xs={12} md={12}>
                <p>
                  <b>Name</b>
                </p>
                <Typography
                  style={{
                    color: "#0000008a",
                    fontSize: 14,
                    marginBottom: "1rem",
                  }}
                >
                  {dataMenu.title}
                </Typography>
                <p>
                  <b>Description</b>
                </p>
                <div
                  style={{
                    minHeight: 100,
                    maxHeight: 100,
                    overflowY: "scroll",
                  }}
                >
                  <Typography
                    style={{
                      color: "#0000008a",
                      fontSize: 14,
                    }}
                  >
                    {parse(dataMenu.description || "")}
                  </Typography>
                </div>
                <p>
                  <b>Product</b>
                </p>
                <div>
                  {dataMenu.product &&
                    dataMenu.product.map((item) => {
                      return (
                        <>
                          {/* <img
                            style={{ width: "4rem", padding: ".5rem" }}
                            src={item.main_image}
                            alt=""
                          /> */}
                          <div
                            class="alert alert-info d-flex justify-content-between align-items-center"
                            role="alert"
                          >
                            <img
                              src={item.main_image}
                              style={{
                                width: "2rem",
                                height: "2rem",
                                marginRight: "1rem",
                              }}
                              alt=""
                            />
                            <div>{item.name}</div>
                            <div></div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          {userTenant == "0" && tabShow === "Request" && (
            <div>
              <Button onClick={setStatusApproved} color="primary">
                Approve
              </Button>
              <Button onClick={setStatusReject} color="primary">
                Reject
              </Button>
            </div>
          )}

          {userTenant != "0" && tabShow === "Request" && (
            <div>
              <Button onClick={doEdit} color="primary">
                Edit
              </Button>
              <Button onClick={setStatusReject} color="primary">
                Remove
              </Button>
            </div>
          )}

          {userTenant != "0" && tabShow === "Approve" && (
            <div>
              <Button onClick={doEdit} color="primary">
                Edit
              </Button>
              <Button onClick={setSForTenantRemove} color="primary">
                Remove
              </Button>
            </div>
          )}

          {userTenant != "0" && tabShow === "Reject" && (
            <Button onClick={setStatusForTenantRestore} color="primary">
              Restore
            </Button>
          )}

          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </CustomizedDialogs>
    </div>
  );
}
export function showDetail(
  title,
  dataMenu,
  deleted,
  approved,
  tabShow,
  access,
  handleGetList,
  options = {}
) {
  return createConfirmation(confirmable(DetailDialog))({
    title,
    dataMenu,
    deleted,
    approved,
    tabShow,
    access,
    handleGetList,
    ...options,
  });
}
